import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  Briefcase,
  DollarSign,
  LifeBuoy,
  Settings,
  Shield,
  Megaphone,
  Link,
  Heart,
  Package,
  BarChart3,
} from "lucide-react";

const navGroups = [
  {
    title: "Overview",
    links: [
      { name: "Dashboard", href: "/admin", icon: LayoutDashboard },
      { name: "Analytics", href: "/admin/analytics", icon: BarChart3 },
    ],
  },
  {
    title: "Identity",
    links: [
      { name: "Fans", href: "/admin/identity/fans", icon: Users },
      { name: "Creators", href: "/admin/identity/creators", icon: Briefcase },
      { name: "System Users", href: "/admin/identity/system", icon: Shield },
    ],
  },
  {
    title: "Monetization",
    links: [
      { name: "Ads", href: "/admin/monetization/ads", icon: Megaphone },
      { name: "Affiliates", href: "/admin/monetization/affiliates", icon: Link },
      { name: "Donations", href: "/admin/monetization/donations", icon: Heart },
      { name: "Inventory", href: "/admin/monetization/inventory", icon: Package },
    ],
  },
  {
    title: "System",
    links: [
      { name: "Finance", href: "/admin/finance", icon: DollarSign },
      { name: "Support", href: "/admin/support", icon: LifeBuoy },
      { name: "Moderation", href: "/admin/moderation", icon: Shield },
      { name: "Roles", href: "/admin/roles", icon: Shield },
      { name: "Audit Logs", href: "/admin/audit", icon: Shield },
      { name: "Settings", href: "/admin/settings", icon: Settings },
    ],
  },
];

const getNavLinkClasses = ({ isActive }) =>
  `flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors ${
    isActive
      ? "bg-purple-700 text-white"
      : "text-slate-300 hover:bg-slate-700 hover:text-white"
  }`;

const AdminSidebar = () => {
  return (
    <aside className="hidden sm:flex w-64 bg-slate-800 text-white flex-col overflow-y-auto">
      <div className="p-4 border-b border-slate-700 sticky top-0 bg-slate-800 z-10">
        <div className="flex items-center">
          <div className="w-10 h-10 bg-purple-600 rounded-lg flex items-center justify-center font-bold text-xl">
            A
          </div>
          <h1 className="ml-3 text-xl font-bold">Adnaki Admin</h1>
        </div>
      </div>
      <nav className="flex-1 p-4 space-y-6">
        {navGroups.map((group) => (
          <div key={group.title}>
            <h3 className="px-3 text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">
              {group.title}
            </h3>
            <div className="space-y-1">
              {group.links.map((link) => (
                <NavLink
                  key={link.name}
                  to={link.href}
                  end={link.href === "/admin"}
                  className={getNavLinkClasses}
                >
                  <link.icon className="w-5 h-5 mr-3" />
                  <span>{link.name}</span>
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </nav>
      <div className="p-4 border-t border-slate-700">
        <p className="text-xs text-slate-400">© 2025 Adnaki Inc.</p>
      </div>
    </aside>
  );
};

export default AdminSidebar;
